@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/design-tokens/typography/typography' as *;

.headerCategoryGroupRoot {
  display: flex;
  align-items: center;
}

.headerCategoryTitle {
  color: var(--text-soft);
  text-transform: uppercase;
  @include typography-v2-body-xs;
  padding: 0 8px 0 24px;
}

.headerItems {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;

  &.options {
    gap: 0;
  }

  @include respond-to('xl') {
    gap: 12px;
  }
}
